import TranscriptionItem from './TranscriptionItem'

export default TranscriptionItem
